import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ListItemComponent, { IStateListItem } from 'components/Abstract/ListItem';
import Alert from 'components/Shared/Alert';
import { IOption } from 'components/Shared/DropdownMenu';
import Snackbar from 'components/Shared/Snackbar';
import { IEntity } from 'interfaces/entity';
import DeleteIcon from 'mdi-react/DeleteIcon';
import EditIcon from 'mdi-react/EditIcon';
import * as React from 'react';
import rxjsOperators from 'rxjs-operators';

import entityService from '../../../../../../services/entity';

interface IState extends IStateListItem {
  deleted?: boolean;
}

interface IProps {
  entity: IEntity;
  onEdit: (entity: IEntity) => void;
  onShowHideComplete: () => void;
  onDeleteComplete: () => void;
  entities: IEntity[],
}

const levelLabels = [
  'Módulo',
  'Aba',
  'Subaba'
];

export default class ListItem extends ListItemComponent<IProps, IState> {
  private readonly options: IOption[];

  constructor(props: IProps) {
    super(props);
    this.options = [
      {
        text: 'Editar',
        icon: EditIcon,
        handler: this.handleEdit
      }, {
        text: 'Excluir',
        icon: DeleteIcon,
        handler: this.handleDelete
      }];
    this.state = {
      ...this.state,
      deleted: false,
    };
  }

  componentDidMount = () => {
    return this.setState({
      deleted: false
    });
  };

  handleEdit = () => {
    const { entity, onEdit } = this.props;
    onEdit(entity);
  };

  handleDelete = async () => {
    const { entity, onDeleteComplete } = this.props;
    const title = `Você tem certeza que deseja excluir ${!entity.level ? 'o' : 'a'} ${levelLabels[entity.level || 0]} "${entity.name}"?`;
    const ok = await Alert.confirm({ title, mode: 'delete' });
    if (!ok) return;
    this.setState({ loading: true });
    entityService.delete(entity.id).pipe(
      rxjsOperators.logError(),
      rxjsOperators.bindComponent(this)
    ).subscribe(() => {
      Snackbar.show(`${entity.name} foi removid${!entity.level ? 'o' : 'a'}`);
      this.setState({ loading: false, deleted: true });
      onDeleteComplete();
    }, error => {
      this.setState({ loading: false, error });
    });
  };

  render(): JSX.Element {
    const { deleted } = this.state;
    const { entity } = this.props;

    if (deleted) {
      return null;
    }

    return (
      <TableRow>
        <TableCell>{entity.ventureName ? entity.ventureName : '-'}</TableCell>
        <TableCell>{entity.name}</TableCell>
        <TableCell>{levelLabels[entity.level || 0]}</TableCell>
        <TableCell>{entity.grandparentName ? entity.grandparentName + ' → ' + entity.parentName : (entity.parentName || '')}</TableCell>
        <TableCell>{ entity.level === 0 ? entity.order : ''}</TableCell>
        <TableCell>
          {this.renderSideMenu(this.options)}
        </TableCell>
      </TableRow>
    );
  }
}